import { loadCards } from "./load_cards"
import { shuffleDeckCollection } from "./shuffle_collection"
import type { Deck } from "."

const deckCollectionSingleton = loadCards()

export const setupDecks = (): Deck.Collection => {
  return shuffleDeckCollection({ decks: deckCollectionSingleton })
}
